import Vue from 'vue'

const WarningInstance = Vue.extend(require('./warning.vue').default);
let instance = null
let warningPromise = null
let warningResolve = null

let getInstance = () => {
  return new WarningInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (warningResolve) {
    warningResolve(null)
    warningResolve = null
  }
  warningPromise = null
}

let Warning = (content) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  warningPromise = new Promise((resolve, reject) => {
    warningResolve = resolve
  })
  instance.open(content, warningResolve)

  return warningPromise
}

export default Warning
